import { SweetAlertIcon, SweetAlertPosition } from 'sweetalert2';

export class Alert {
    title?: string; 
    text?: string;
    icon?: SweetAlertIcon;
    timer?: number = 3500;
    position?: SweetAlertPosition = 'top-end';
    timerProgressBar?: boolean = true;
    showConfirmButton?: boolean = false;
    showCloseButton?: boolean = false;
 }